module.exports = __webpack_public_path__ + "img/treatments-directory-card-desktop-en.f431972a.jpg";